import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import MUIDataTable from 'mui-datatables';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Upload from '../../../components/Input/Upload';
import Modal from '../../../components/Modal';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config';
import { GET, newFetch, POST, PUT } from '../../../helpers/fetch';
const { API_URL, SERVER_URL } = config;

const LeaveCreditsFilling = ({ history }) => {
  const useStyles = makeStyles({
    NameCell: {
      fontWeight: 900,
    },
  });

  const token = localStorage.getItem('token');
  const classes = useStyles();
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const [loading, setLoading] = useState(true);
  const [leaves, setLeaves] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [editStatus, setEditStatus] = useState(0);
  const [editRemarksAho, setEditRemarksAho] = useState('');
  const [editRemarksAdmin, setEditRemarksAdmin] = useState('');

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [applyStatus, setApplyStatus] = useState('pending');
  const [applyAdminRemarks, setApplyAdminRemarks] = useState('');
  const [selectedAssociate, setSelectedAssociate] = useState(0);
  const [selectedLeaveType, setSelectedLeaveType] = useState(0);
  const [files, setFiles] = useState([]);
  const [leaveCredits, setLeaveCredits] = useState('');
  const [usedLeaves, setUsedLeaves] = useState('');
  const [leaveFrom, setLeaveFrom] = useState('');
  const [leaveTo, setLeaveTo] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [leaveToEdit, setLeaveToEdit] = useState(null);
  const periodType = ['Full Day', 'AM', 'PM'];
  const [selectedPeriodType, setSelectedPeriodType] = useState('Full Day');
  const [isDisabled, setIsDisabled] = useState(false);
  const [clients, setClients] = useState([]);

  const leaveFromHandler = (e) => {
    setLeaveFrom(e.target.value);
    if (selectedPeriodType !== 'Full Day') {
      setLeaveTo(e.target.value);
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  };
  const leaveToHandler = (e) => setLeaveTo(e.target.value);

  //Apply handlers
  const handleApply = () => {
    setShowApplyModal(true);
  };
  const handleApplyClose = () => {
    setFiles([]);
    setApplyStatus('pending');
    setSelectedLeaveType(0);
    setSelectedAssociate(0);
    setApplyAdminRemarks('');
    setLeaveCredits('');
    setUsedLeaves('');
    setSelectedPeriodType('Full Day');
    setIsDisabled(false);
    setShowApplyModal(false);
  };
  const handleAssociateSelection = (id) => {
    setSelectedAssociate(id);
  };

  const handleLeaveTypeSelection = (id) => {
    setSelectedLeaveType(id);
  };

  const handlePeriodTypeSelection = (value) => {
    setSelectedPeriodType(value);
    if (value != 'Full Day') {
      setIsDisabled(true);
      setLeaveFrom('');
      setLeaveTo('');
    } else {
      setIsDisabled(false);
    }
  };

  const handleApplySubmit = async () => {
    if (selectedAssociate == 0) {
      ToastUtil.error('Select associate');
    } else if (setSelectedLeaveType == 0) {
      ToastUtil.error('Select type');
    } else {
      let formData = new FormData();
      formData.append('associate_id', selectedAssociate);
      formData.append('leave_type', selectedLeaveType);
      formData.append('leave_from', leaveFrom);
      formData.append('leave_to', leaveTo);
      formData.append('leave_period', selectedPeriodType);
      formData.append('remarks_admin', applyAdminRemarks);
      formData.append('status', applyStatus);
      formData.append('file', files[0]);

      const api_path = `/leaves`;
      let response = await newFetch(POST, api_path, formData, 'multi');

      ToastUtil.success(response.message);

      if (response.success) {
        handleApplyClose();
        fetchLeaves();
      }
    }
  };

  const handleEditSubmit = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update the leave?'
      )
    ) {
      let api_path = `/leaves/${leaveToEdit.id}`;
      let response = await newFetch(PUT, api_path, {
        editRemarksAho,
        editRemarksAdmin,
        editStatus,
      });

      ToastUtil.success(response.message);
      if (response.success) {
        handleEditClose();
        fetchLeaves();
      }
    }
  };

  const handleEdit = (id) => {
    let leave = leaves.find((leave) => leave.id == id);

    setLeaveToEdit(leave);
    setEditRemarksAho(leave.remarks_by_aho);
    setEditRemarksAdmin(leave.remarks_by_admin);
    setEditStatus(leave.status);
    setShowEditModal(true);
  };

  const handleEditClose = () => {
    setLeaveToEdit(null);
    setEditRemarksAho('');
    setEditRemarksAdmin('');
    setEditStatus(0);
    setShowEditModal(false);
  };

  const fetchLeaves = async () => {
    try {
      const fetchUrl = `${API_URL}/leaves`;
      let response = await fetch(fetchUrl, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
      if (!response.ok) {
        console.log('error');
      } else {
        const leaves = await response.json();

        setLeaves(leaves.data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAssociates = async () => {
    try {
      const api_path = `/active_associate_by_name`;
      let response = await newFetch(GET, api_path);
      if (response.success) {
        let associates = response.data;
        setAssociates(associates);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTypes = async () => {
    try {
      const api_path = `/leavetypes`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setLeaveTypes(response.data);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  useEffect(() => {
    let assocLeaveCredits = associates.find(
      (assoc) => assoc.id == selectedAssociate
    );

    let assocUsedLeaves = leaves
      .filter((leave) => leave.associate_id == selectedAssociate)
      .filter(
        (assoc) =>
          assoc.leave_type == selectedLeaveType &&
          assoc.status !== 'rejected' &&
          assoc.status !== 'canceled'
      )
      .reduce((total, assoc) => parseFloat(total) + parseFloat(assoc.days), 0);

    setLeaveFrom('');
    setLeaveTo('');
    setUsedLeaves(assocUsedLeaves);
    setLeaveCredits(assocLeaveCredits);
  }, [selectedAssociate, selectedLeaveType]);

  useEffect(() => {
    fetchLeaves();
    fetchAssociates();
    fetchTypes();
  }, []);

  useEffect(() => {
    fetchClients();
  }, [clientID]);

  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: false,
        display: false,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'associate_id',
      label: 'Associate Id',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'client',
      label: 'Client',
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'site',
      label: 'Site',
      options: {
        filter: true,
        sort: true,
        display: false,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'leave_type_name',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'date_range',
      label: 'Date Range',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'updatedAt',
      label: 'Date Modified',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'Action',
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.rowData[5] != 'Cancelled' ? (
            <button
              className="btn btn-brand"
              onClick={() => handleEdit(tableMeta.rowData[0])}
            >
              Edit
            </button>
          ) : null;
        },
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    download: true,
    print: false,
    sort: true,
    viewColumns: false,
  };

  if (loading) {
    return <div>loading</div>;
  } else {
    return (
      <>
        <div
          className="container-fluid"
          style={{
            paddingLeft: '2rem',
            paddingRight: '2rem',
            paddingBottom: '6rem',
          }}
        >
          <div className="border-bottom pb-2 py-2 d-flex align-items-center">
            <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
              Leave Credit & Filling
            </h6>
            {clients.enable_leave_credits && (
              <div className="d-flex align-items-center">
                <button
                  onClick={() => handleApply()}
                  className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
                  style={{ width: '200px' }}
                >
                  Apply Leave
                </button>
              </div>
            )}
          </div>
          {clients.enable_leave_credits ? (
            <>
              <MUIDataTable
                title={'Leave Credit & Filling'}
                data={leaves}
                columns={columns}
                options={options}
              ></MUIDataTable>
            </>
          ) : (
            <div className="text-muted pt-4">
              The client does not have access to this module.
            </div>
          )}
        </div>
        {leaveToEdit && (
          <Modal showModal={showEditModal} hideModal={handleEditClose}>
            <h5>Edit Leave</h5>
            <div className="edit-leave-wrapper">
              <div className="header-thick">Associate Name</div>
              <div className="edit-leave-values">{leaveToEdit.name}</div>

              <div className="header-thick">Type</div>
              <div className="edit-leave-values">
                {leaveToEdit.leave_type_name}
              </div>
              {leaveToEdit.leave_period && (
                <>
                  <div className="header-thick">Leave Period</div>
                  <div className="edit-leave-values">
                    {leaveToEdit.leave_period}
                  </div>
                </>
              )}
              <div className="header-thick">Date Range</div>
              <div className="edit-leave-values">{leaveToEdit.date_range}</div>
              {leaveToEdit.new_file && (
                <>
                  <div className="header-thick">File</div>
                  <div className="edit-leave-values">
                    <a
                      href={`${SERVER_URL}/storage/leaves/${leaveToEdit.new_file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {leaveToEdit.orig_file}
                    </a>
                  </div>
                </>
              )}

              <div className="header-thick mt-3">Days</div>
              <div className="edit-leave-values">{leaveToEdit.count_days}</div>

              <div className="header-thick">Status</div>
              <select
                name="editStatus"
                id="editStatus"
                value={editStatus}
                className="form-select  edit-leave-values"
                onChange={(e) => setEditStatus(e.target.value)}
              >
                <option value={'pending'}>Pending</option>
                <option value={'rejected'}>Rejected</option>
                <option value={'approved'}>Approved</option>
                {/* <option value={'cancelled'}>Cancelled</option> */}
              </select>
              <div className="header-thick">Associate Remarks</div>
              <textarea
                className="form-control"
                rows="5"
                style={{ resize: 'none' }}
                placeholder="Remarks"
                id="Remarks"
                name="Remarks"
                value={editRemarksAho}
                onChange={({ target: { value } }) => setEditRemarksAho(value)}
              />

              <div className="header-thick mt-3">Approver/Admin Remarks</div>
              <textarea
                className="form-control"
                rows="5"
                style={{ resize: 'none' }}
                placeholder="Admin Remarks"
                id="AdminRemarks"
                name="adminRemarks"
                value={editRemarksAdmin}
                onChange={({ target: { value } }) => setEditRemarksAdmin(value)}
              />
              <div className="edit-button-wrapper">
                <button
                  type="button"
                  onClick={() => handleEditClose()}
                  className="btn btn-outline-brand"
                  style={{ width: '12rem' }}
                >
                  Discard
                </button>
                <button
                  onClick={() => handleEditSubmit()}
                  className="btn btn-brand ms-3"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </div>
          </Modal>
        )}
        <Modal showModal={showApplyModal} hideModal={handleApplyClose}>
          <h5>Apply Leave</h5>
          <div className="edit-leave-wrapper">
            <div className="header-thick">Associate Name</div>
            <select
              name="applyAssociate"
              id="applyAssociate"
              value={selectedAssociate}
              className="form-select  edit-leave-values"
              onChange={(e) => handleAssociateSelection(e.target.value)}
            >
              <option value="">Select Associate</option>
              {associates.map((associate) => (
                <option value={associate.id} key={associate.id}>
                  {associate.first_name + ' ' + associate.last_name}
                </option>
              ))}
            </select>

            <div className="header-thick">Type</div>
            <select
              name="applyType"
              id="applyType"
              value={selectedLeaveType}
              className="form-select  edit-leave-values"
              onChange={(e) => handleLeaveTypeSelection(e.target.value)}
            >
              <option value="">Select Type</option>
              {leaveTypes.map((type) => (
                <option value={type.id} key={type.id}>
                  {type.status}
                </option>
              ))}
            </select>

            {selectedLeaveType == 1 && (
              <>
                <div className="header-thick">Leave Period</div>
                <div className="">
                  {periodType.map((type, index) => (
                    <div className="form-check me-3 mb-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="itemType"
                        id={`itemType-${index}`}
                        value={type}
                        checked={type === selectedPeriodType}
                        onChange={({ target: { value } }) =>
                          handlePeriodTypeSelection(value)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`itemType-${index}`}
                      >
                        {type}
                      </label>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className="header-thick mt-2">Leave Available</div>
            <div className="edit-leave-values">
              {selectedLeaveType && leaveCredits?.credits.length > 0
                ? leaveCredits?.credits.find(
                    (credit) => credit.type == selectedLeaveType
                  )?.total - usedLeaves
                : '0'}
            </div>

            <div className="header-thick">Leave From</div>
            <input
              type="date"
              className="form-control edit-leave-values"
              value={leaveFrom}
              onChange={(e) => leaveFromHandler(e)}
            />

            <div className="header-thick">Leave To</div>
            <input
              type="date"
              className="form-control edit-leave-values"
              value={leaveTo}
              disabled={isDisabled}
              onChange={(e) => leaveToHandler(e)}
            />

            {selectedLeaveType == 3 && (
              <div className="mb-2 py-2">
                <label htmlFor="instructionUpload">
                  <span className="header-thick">Upload Files</span>
                </label>
                <Upload
                  files={files}
                  setFiles={setFiles}
                  accept={' image/jpg, image/jpeg, image/png'}
                />
              </div>
            )}

            <div className="header-thick">Status</div>
            <select
              name="editStatus"
              id="editStatus"
              value={applyStatus}
              className="form-select edit-leave-values"
              onChange={(e) => setApplyStatus(e.target.value)}
            >
              <option value={'pending'}>Pending</option>
              <option value={'rejected'}>Rejected</option>
              <option value={'approved'}>Approved</option>
            </select>
            <div className="header-thick">Approver/Admin Remarks</div>
            <textarea
              className="form-control mb-3"
              rows="5"
              style={{ resize: 'none' }}
              placeholder="Remarks"
              id="Remarks"
              name="Remarks"
              value={applyAdminRemarks}
              onChange={({ target: { value } }) => setApplyAdminRemarks(value)}
            />
            <div className="edit-button-wrapper">
              <button
                type="button"
                onClick={() => handleApplyClose()}
                className="btn btn-outline-brand"
                style={{ width: '12rem' }}
              >
                Close
              </button>
              <button
                onClick={() => handleApplySubmit()}
                className="btn btn-brand ms-3"
                style={{ width: '12rem' }}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
};

export default withRouter(LeaveCreditsFilling);
